export default {"src":"/_next/static/media/popular-icon-redesigned.9fa3ecb1.svg","height":16,"width":16};